import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { validatePassword, validatePasswordConfirm } from '../../../utils/validation';
import { Modal } from '../../common';

/**
 * Change password modal for Profile page
 */
const ChangePasswordModal = ({ isOpen, onClose, onSubmit }) => {
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate new password
    const passwordError = validatePassword(passwordData.newPassword);
    if (passwordError) {
      toast.error(passwordError);
      return;
    }

    // Validate confirmation
    const confirmError = validatePasswordConfirm(passwordData.newPassword, passwordData.confirmPassword);
    if (confirmError) {
      toast.error(confirmError);
      return;
    }
    
    const success = await onSubmit(passwordData.currentPassword, passwordData.newPassword);
    if (success) {
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    }
  };

  const handleClose = () => {
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Change Password"
      footer={
        <>
          <button
            type="button"
            onClick={handleClose}
            className="btn-secondary mr-4"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="btn-primary"
          >
            Change Password
          </button>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="form-label-small text-secondary">Current Password</label>
          <input
            type="password"
            name="currentPassword"
            value={passwordData.currentPassword}
            onChange={handleChange}
            className="form-input mt-1 block w-full px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            required
          />
        </div>
        
        <div>
          <label className="form-label-small text-secondary">New Password</label>
          <input
            type="password"
            name="newPassword"
            value={passwordData.newPassword}
            onChange={handleChange}
            className="form-input mt-1 block w-full px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            required
            minLength={6}
          />
          <p className="mt-1 text-xs text-secondary">
            Must be at least 6 characters long
          </p>
        </div>
        
        <div>
          <label className="form-label-small text-secondary">Confirm New Password</label>
          <input
            type="password"
            name="confirmPassword"
            value={passwordData.confirmPassword}
            onChange={handleChange}
            className="form-input mt-1 block w-full px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            required
          />
        </div>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;
